// Copyright (c) 2019 Deere & Company
import moment from 'moment';
import React from 'react';

const cellRenderer = params => (
    <a name="claimNumber" data-warrantyClaimId={params.data.warrantyClaimId}>
        {params.data.claimNumber}
    </a>
);

const agcmdlColumnDefinitions = [
    // {
    //     checkboxSelection: true,
    //     width: 75,
    // },
   {
        headerName: "All",
        field: "checkbox",
        width: 10,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        pinned:'left'
    },

    {
        field: 'branchId',
        headerName: 'Unit',
        sortable: true,
        filter: true,
        width: 80,
    },
    {
        field: 'claimNumber',
        headerName: 'Claim Number',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
        cellRenderer
    },
    {
        field: 'dealerNumber',
        headerName: 'Dealer',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
    {
        field: 'delaerWorkOrderNum',
        headerName: 'Dealer WON',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
    {
        field: 'claimType',
        headerName: 'Claim Type',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
   
    {
        field: 'creditMemoNum',
        headerName: 'Cr Memo#',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },

    {
        field: 'dealerClaimRefNum',
        headerName: 'Cl.Ref. #',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
    {
        field: 'partsTotal',
        headerName: 'Parts Total',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
    {
        field: 'laborTotal',
        headerName: 'Labor Total',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
    {
        field: 'totalClaimAmount',
        headerName: 'Cr Memo Total',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
    {
        field: 'pin.digit13',
        headerName: 'PIN',
        sortable: true,
        filter: true,
        width: 120,
    },
   
   
    {
        field: 'part.partNumber',
        headerName: 'Part Number',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'claimCurrencyType',
        headerName: 'Crncy Type',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
    },
    {
        field: 'claimRcvdDate',
        headerName: 'Claim Submitted Date',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },

];
export default agcmdlColumnDefinitions;
